var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Detalles del Documento " + _vm.file.id,
        "no-close-on-backdrop": "",
        centered: "",
        "hide-footer": "",
        "content-class": "fullscreen",
        size: "xl",
        scrollable: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _vm.loading
        ? _c("vs-progress", {
            staticClass: "mb-1",
            attrs: { indeterminate: "", color: "primary" }
          })
        : _vm._e(),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h4", [_vm._v("Datos del documento")])
            ]),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c(
                  "b-badge",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Folio",
                        expression: "'Folio'"
                      }
                    ],
                    staticClass: "text-wrap mb-4",
                    attrs: { variant: "light-info" }
                  },
                  [
                    _c("feather-icon", { attrs: { icon: "CodeIcon" } }),
                    _vm._v(" " + _vm._s(_vm.file.folio) + " ")
                  ],
                  1
                ),
                _c(
                  "b-badge",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Fecha de creación",
                        expression: "'Fecha de creación'"
                      }
                    ],
                    staticClass: "text-wrap ml-2 mb-4",
                    attrs: { variant: "light-info" }
                  },
                  [
                    _c("feather-icon", { attrs: { icon: "CalendarIcon" } }),
                    _vm._v(" " + _vm._s(_vm.file.createdAt) + " ")
                  ],
                  1
                ),
                _c(
                  "b-badge",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Tipo",
                        expression: "'Tipo'"
                      }
                    ],
                    staticClass: "text-wrap ml-2 mb-4",
                    attrs: { variant: "light-info" }
                  },
                  [
                    _c("feather-icon", { attrs: { icon: "InfoIcon" } }),
                    _vm._v(" " + _vm._s(_vm.file.typeDescription) + " ")
                  ],
                  1
                ),
                _c("h6", [_vm._v("Materia")]),
                _c("p", [_vm._v(_vm._s(_vm.file.theme))]),
                _c("h6", [_vm._v("Descripción")]),
                _c("p", [_vm._v(_vm._s(_vm.file.description))]),
                _c(
                  "div",
                  {
                    staticClass: "float-right",
                    on: {
                      click: function($event) {
                        return _vm.getFile(_vm.file.url)
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      { staticClass: "btn btn-icon btn-primary btn-sm" },
                      [_c("feather-icon", { attrs: { icon: "DownloadIcon" } })],
                      1
                    )
                  ]
                ),
                _c("div", { staticClass: "clearfix" })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h4", [_vm._v("Archivos Anexos")])
            ]),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                !_vm.file.relatedDocuments.length
                  ? _c("p", [_vm._v(" No tiene archivos anexos ")])
                  : _vm._e(),
                _vm._l(_vm.file.relatedDocuments, function(relatedFile) {
                  return _c(
                    "a",
                    {
                      key: relatedFile.if,
                      staticClass: "btn btn-outline-secondary btn-sm mr-1 mb-1",
                      on: {
                        click: function($event) {
                          return _vm.getFile(relatedFile.url, relatedFile.name)
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(relatedFile.name) + " "),
                      _c("feather-icon", { attrs: { icon: "DownloadIcon" } })
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h4", [_vm._v("Destinatarios")])
            ]),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c(
                  "vs-table",
                  { attrs: { stripe: "", data: _vm.file.targetUsers || [] } },
                  [
                    _c("template", { slot: "header" }),
                    _c(
                      "template",
                      { slot: "thead" },
                      [
                        _c("vs-th", [_vm._v(" Nombre ")]),
                        _c("vs-th", [_vm._v(" Estado ")]),
                        _c("vs-th", [_vm._v(" Motivo ")])
                      ],
                      1
                    ),
                    [
                      _c(
                        "tbody",
                        _vm._l(_vm.file.targetUsers || [], function(user) {
                          return _c(
                            "vs-tr",
                            { key: user.usuarioId },
                            [
                              _c("vs-td", [
                                _vm._v(" " + _vm._s(user.usuarioNombre) + " ")
                              ]),
                              _c(
                                "vs-td",
                                [
                                  user.estadoProceso === "RECIBIDO"
                                    ? _c(
                                        "vs-chip",
                                        {
                                          attrs: {
                                            title: "Recibido",
                                            "data-cy": "received"
                                          }
                                        },
                                        [
                                          _c("vs-avatar", {
                                            attrs: {
                                              icon: "thumb_up",
                                              color: "#28c76f"
                                            }
                                          }),
                                          _vm._v(" Recibido ")
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  user.estadoProceso === "PENDIENTE"
                                    ? _c(
                                        "vs-chip",
                                        {
                                          attrs: {
                                            title: "Pendiente",
                                            "data-cy": "pending"
                                          }
                                        },
                                        [
                                          _c("vs-avatar", {
                                            attrs: {
                                              icon: "warning",
                                              color: "#ff9f43"
                                            }
                                          }),
                                          _vm._v(" Pendiente ")
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  user.estadoProceso === "RECHAZADO"
                                    ? _c(
                                        "vs-chip",
                                        {
                                          attrs: {
                                            title: "Rechazado",
                                            "data-cy": "rejected"
                                          }
                                        },
                                        [
                                          _c("vs-avatar", {
                                            attrs: {
                                              icon: "thumb_down",
                                              color: "#ea5455"
                                            }
                                          }),
                                          _vm._v(" Rechazado ")
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  ![
                                    "RECHAZADO",
                                    "PENDIENTE",
                                    "RECIBIDO"
                                  ].includes(user.estadoProceso)
                                    ? _c(
                                        "vs-chip",
                                        {
                                          attrs: {
                                            title: user.estadoProceso,
                                            "data-cy":
                                              "copy-state-" + user.estadoProceso
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(user.estadoProceso) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("vs-td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      user.estadoProceso === "RECHAZADO"
                                        ? user.estadoMotivo
                                        : "-"
                                    ) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ]
                  ],
                  2
                )
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h4", [_vm._v("Datos del creador")])
            ]),
            _c("div", { staticClass: "card-body" }, [
              _c("h6", [_vm._v("Correo")]),
              _c("p", [_vm._v(_vm._s(_vm.file.creatorEmail))]),
              _c("h6", [_vm._v("Nombre")]),
              _c("p", [_vm._v(_vm._s(_vm.file.creatorName))]),
              _c("h6", [_vm._v("Entidad")]),
              _c("p", [_vm._v(_vm._s(_vm.file.creatorEntityName))])
            ])
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h4", [_vm._v("Firmado por:")])
            ]),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                !_vm.file.signers.length
                  ? _c("p", [_vm._v(" No tiene firmantes ")])
                  : _vm._e(),
                _vm._l(_vm.file.signers, function(user) {
                  return _c(
                    "b-media",
                    {
                      key: user.id,
                      staticClass: "mb-2",
                      attrs: { "no-body": "" }
                    },
                    [
                      _c(
                        "b-media-aside",
                        { staticClass: "mr-75" },
                        [
                          _c("b-avatar", { attrs: { rounded: "", size: "36" } })
                        ],
                        1
                      ),
                      _c("b-media-body", { staticClass: "my-auto" }, [
                        _c("h6", { staticClass: "mb-0" }, [
                          _vm._v(" " + _vm._s(user.name) + " ")
                        ]),
                        _c("small", [_vm._v(_vm._s(user.entityName))])
                      ])
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h4", [_vm._v("Visadores:")])
            ]),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                !_vm.file.certifiers.length
                  ? _c("p", [_vm._v(" No tiene visadores ")])
                  : _vm._e(),
                _vm._l(_vm.file.certifiers, function(user) {
                  return _c(
                    "b-media",
                    {
                      key: user.id,
                      staticClass: "mb-2",
                      attrs: { "no-body": "" }
                    },
                    [
                      _c(
                        "b-media-aside",
                        { staticClass: "mr-75" },
                        [
                          _c("b-avatar", { attrs: { rounded: "", size: "36" } })
                        ],
                        1
                      ),
                      _c("b-media-body", { staticClass: "my-auto" }, [
                        _c("h6", { staticClass: "mb-0" }, [
                          _vm._v(" " + _vm._s(user.name) + " ")
                        ]),
                        _c("small", [_vm._v(_vm._s(user.entityName))])
                      ])
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]),
          !!_vm.withCopyEntity.length
            ? _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("h4", [_vm._v("Con copia a")])
                ]),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c(
                      "vs-table",
                      { attrs: { stripe: "", data: _vm.withCopyEntity || [] } },
                      [
                        _c("template", { slot: "header" }),
                        _c(
                          "template",
                          { slot: "thead" },
                          [
                            _c("vs-th", [_vm._v(" Nombre ")]),
                            _c("vs-th", [_vm._v(" Estado ")]),
                            _c("vs-th", [_vm._v(" Motivo ")])
                          ],
                          1
                        ),
                        [
                          _c(
                            "tbody",
                            _vm._l(_vm.withCopyEntity || [], function(entity) {
                              return _c(
                                "vs-tr",
                                { key: entity.entidadId },
                                [
                                  _c("vs-td", [
                                    _vm._v(
                                      " " + _vm._s(entity.entidadNombre) + " "
                                    )
                                  ]),
                                  _c(
                                    "vs-td",
                                    [
                                      entity.estado === "RECIBIDO"
                                        ? _c(
                                            "vs-chip",
                                            {
                                              attrs: {
                                                title: "Recibido",
                                                "data-cy": "received"
                                              }
                                            },
                                            [
                                              _c("vs-avatar", {
                                                attrs: {
                                                  icon: "thumb_up",
                                                  color: "#28c76f"
                                                }
                                              }),
                                              _vm._v(" Recibido ")
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      entity.estado === "PENDIENTE"
                                        ? _c(
                                            "vs-chip",
                                            {
                                              attrs: {
                                                title: "Pendiente",
                                                "data-cy": "pending"
                                              }
                                            },
                                            [
                                              _c("vs-avatar", {
                                                attrs: {
                                                  icon: "warning",
                                                  color: "#ff9f43"
                                                }
                                              }),
                                              _vm._v(" Pendiente ")
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      entity.estado === "RECHAZADO"
                                        ? _c(
                                            "vs-chip",
                                            {
                                              attrs: {
                                                title: "Rechazado",
                                                "data-cy": "rejected"
                                              }
                                            },
                                            [
                                              _c("vs-avatar", {
                                                attrs: {
                                                  icon: "thumb_down",
                                                  color: "#ea5455"
                                                }
                                              }),
                                              _vm._v(" Rechazado ")
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      ![
                                        "RECHAZADO",
                                        "PENDIENTE",
                                        "RECIBIDO"
                                      ].includes(entity.estado)
                                        ? _c(
                                            "vs-chip",
                                            {
                                              attrs: {
                                                title: entity.estado,
                                                "data-cy":
                                                  "copy-state-" + entity.estado
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(entity.estado) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c("vs-td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          entity.estado === "RECHAZADO"
                                            ? entity.motivo
                                            : "-"
                                        ) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ]
                      ],
                      2
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }